/**
 * Calculates a visually clean step size for chart Y-axis.
 * Aims for approximately 4-6 ticks on each side of zero.
 */
const calculateNiceStepSize = (maxValue: number): number => {
  if (maxValue <= 0) return 1;

  const roughStep = maxValue / 5;
  const magnitude = Math.pow(10, Math.floor(Math.log10(roughStep)));
  const normalized = roughStep / magnitude;

  let niceStep: number;
  if (normalized <= 1) {
    niceStep = 1;
  } else if (normalized <= 2) {
    niceStep = 2;
  } else if (normalized <= 2.5) {
    niceStep = 2.5;
  } else if (normalized <= 5) {
    niceStep = 5;
  } else {
    niceStep = 10;
  }

  return niceStep * magnitude;
};

export default calculateNiceStepSize;
